export const curveSegments = 128;
export const wallThickness = 3;
export const grooveThickness = 1.5;
export const maxPrintHeight = 250;